export const GET_WEIGHT_REQUEST = 'GET_WEIGHT_REQUEST' as const;
export const GET_WEIGHT_SUCCESS = 'GET_WEIGHT_SUCCESS' as const;
export const GET_WEIGHT_ERROR = 'GET_WEIGHT_ERROR' as const;
export const CLEAR_WEIGTH_STATE = 'CLEAR_WEIGTH_STATE' as const;
